import $ from 'jquery';
import QuickAdd from '../global/QuickAdd';
import Section from '../Section';

function get_unique_array(array) {
  var newArray = new Array();
  var handleArray = new Array();

  for (var i = 0; i < array.length; i++) {
    var handle = array[i]['handle'];
    if (handleArray.indexOf(handle) === -1) {
      newArray.push(array[i]);
      handleArray.push(handle);
    }
  }
  return newArray;
}

export default class RecentlyViewed extends Section {
  RECENTLY_VIEWED_LOCAL_STORAGE_KEY = 'recentlyVisited';
  PLACEHOLDER = 'PLACEHOLDER';

  /**
   * @param {import('../ThemeBase').default} theme
   * @param {HTMLElement} element
   */
  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);

    this.$element = $(element);
    this.handle = this.element.dataset.productHandle;
    this.productUrl = this.element.dataset.productUrl;
    this.$content = this.$element.find('#recently-viewed-products');
    this.layoutStyle = this.element.dataset.layoutStyle;
    this.layoutClasses = this.element.dataset.layoutClasses;
    this.productsToShow = parseInt(this.element.dataset.productsToShow);
    this.quickShopDesktopEnabled = this.element.dataset.quickShopDesktopEnabled;
    this.quickShopMobileEnabled = this.element.dataset.quickShopMobileEnabled;

    if (this.$content.hasClass('recently-viewed-loading')) {
      return;
    }

    this.$content.empty().addClass('recently-viewed-loading');

    var recentlyViewedJSON = null;

    if (this._isLocalStorageSupported()) {
      recentlyViewedJSON = localStorage.getItem(this.RECENTLY_VIEWED_LOCAL_STORAGE_KEY);
    }

    var recentlyViewed = recentlyViewedJSON != null ? JSON.parse(recentlyViewedJSON) : [];

    if (this.handle) {
      var item = {
        'handle': this.handle,
      };
      recentlyViewed.unshift(item);
    }

    var uniqueArray = recentlyViewed.length ? get_unique_array(recentlyViewed) : recentlyViewed;
    this.productsToShow = this.productsToShow + (this.handle ? 1 : 0);
    
    if (uniqueArray.length > this.productsToShow) {
      uniqueArray = uniqueArray.slice(0, this.productsToShow);
    }

    if (this._isLocalStorageSupported()) {
      localStorage.setItem(this.RECENTLY_VIEWED_LOCAL_STORAGE_KEY, JSON.stringify(uniqueArray));
    }

    if (uniqueArray.length > 1 || (uniqueArray.length === 1 && uniqueArray[0]['handle'] !== this.handle)) {
      this.loadProducts(uniqueArray.filter((item) => { return item.handle !== this.handle }));
    } else {
      this.$element.remove();
    }
  }

  loadProducts = (recentlyViewed) => {
    var promises = recentlyViewed.map(function (rv) {
      return $.get(this.productUrl.replace(this.PLACEHOLDER, rv.handle));
    }.bind(this));

    $.when.apply($, promises)
      .then(() => {
        let allOK = true;

        promises.forEach((promise) => {
          if (promise.status === 200) {
            var container = document.createElement('div');
            container.innerHTML = promise.responseText;

            this.$content.append(
              container.querySelector('.main-content .grid__item').outerHTML
            );

            if (this.layoutStyle !== 'grid') {
              this.$content.find('.grid__item').addClass('swiper-slide').addClass(this.layoutClasses);
            } else {
              this.$content.find('.grid__item').addClass(this.layoutClasses);
            }

          } else {
            console.warn('Unable to fetch recently visited product: ', promise.status, promise.responseText);
            allOK = false;
          }
        });

        if (allOK) {
          this.show();
        }
        else {
          this.hideButtons();
        }
      });
  }

  hideButtons = () => {
    this.$element.find('.swiper-button--next').hide();
    this.$element.find('.swiper-button--prev').hide();
  }

  show = () => {
    this.$element.fadeIn();

    this.loadShopNow();
    this.quickAddButtons = new QuickAdd(this.theme, this.element);
    this.badge = this.theme.addBadges(this.element, 1000);

    const sectionLoadedEvent = new CustomEvent('theme:section:load');
    document.dispatchEvent(sectionLoadedEvent);

    const recentlyViewedLoadedEvent = new CustomEvent('recentlyViewed:loaded');
    document.dispatchEvent(recentlyViewedLoadedEvent);
  }

  loadShopNow = () => {
    if (this.quickShopDesktopEnabled === 'true' || (this.quickShopMobileEnabled === 'true')) {
      const quickAddButtons = this.element.querySelectorAll('.quick-add-button-variants');
      quickAddButtons.forEach((button) => {
        button.addEventListener('click', this.handleShopNow.bind(this));
      });
    }
  }

  handleShopNow = (e) => {
    e.preventDefault();
    this.theme.toggleRightDrawer('shop-now', true, { url: e.currentTarget.href });
  }

  _isLocalStorageSupported = () => {
    try {
      return typeof Storage != "undefined" && window.localStorage && window.sessionStorage ? true : false;
    } catch (e) {
      return false;
    }
  }

  paramStr = (arr) => {
    var parameters = [];
    for (var property in arr) {
      if (Object.prototype.hasOwnProperty.call(arr, property) && arr[property].length > 0) {
        parameters.push(encodeURI(arr[property]));
      }
    }

    return parameters.join(',');
  }

  // check if we're on mobile
  isMobile = () => {
    return window.matchMedia('(max-width: 1023px)').matches;
  }
}
